import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AttendanceList = ({ attendance, onRefresh, onCheckOut }) => {
  const [checkingOut, setCheckingOut] = useState(null);

  const handleCheckOut = async (logId) => {
    setCheckingOut(logId);
    try {
      await onCheckOut(logId);
      onRefresh();
    } catch (error) {
      console.error('Error checking out:', error);
    } finally {
      setCheckingOut(null);
    }
  };

  const formatDuration = (minutes) => {
    if (!minutes) return 'N/A';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  };

  return (
    <div className="bg-card rounded-lg border border-border">
      <div className="p-6 border-b border-border flex items-center justify-between">
        <h2 className="text-xl font-bold">Recent Attendance</h2>
        <Button
          onClick={onRefresh}
          variant="outline"
          size="sm"
          iconName="RefreshCw"
        >
          Refresh
        </Button>
      </div>
      <div className="overflow-x-auto">
        {attendance?.length === 0 ? (
          <div className="p-12 text-center">
            <Icon name="Users" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No attendance records found</p>
          </div>
        ) : (
          <table className="w-full">
            <thead className="bg-muted">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Member
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Check-in
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Check-out
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Entry Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {attendance?.map((log) => (
                <tr key={log?.id} className="hover:bg-muted/50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center overflow-hidden">
                        {log?.user_profiles?.avatar_url ? (
                          <img
                            src={log?.user_profiles?.avatar_url}
                            alt={log?.user_profiles?.full_name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <Icon name="User" size={20} className="text-primary" />
                        )}
                      </div>
                      <div>
                        <p className="font-medium text-foreground">
                          {log?.user_profiles?.full_name}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {log?.user_profiles?.email}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <Icon name="LogIn" size={16} className="text-success" />
                      <span className="text-sm">
                        {new Date(log?.check_in_time)?.toLocaleString()}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {log?.check_out_time ? (
                      <div className="flex items-center gap-2">
                        <Icon name="LogOut" size={16} className="text-destructive" />
                        <span className="text-sm">
                          {new Date(log?.check_out_time)?.toLocaleString()}
                        </span>
                      </div>
                    ) : (
                      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                        <Icon name="Activity" size={12} />
                        Active
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm">
                      {formatDuration(log?.duration_minutes)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-muted text-foreground capitalize">
                      {log?.entry_type?.replace('_', ' ')}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {!log?.check_out_time && (
                      <Button
                        onClick={() => handleCheckOut(log?.id)}
                        variant="outline"
                        size="sm"
                        loading={checkingOut === log?.id}
                        iconName="LogOut"
                      >
                        Check Out
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AttendanceList;